import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/apiClient";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=unauth, obj=auth
  const [employee, setEmployee] = useState(null);
  const [company, setCompany] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setEmployee(data.employee || null);
      setCompany(data.company || null);
    } catch {
      setUser(false);
      setEmployee(null);
      setCompany(null);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    localStorage.removeItem("kqm_mode");
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("kqm_token", data.token);
    await refresh();
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (err) { console.error("Logout request failed:", err); }
    localStorage.removeItem("kqm_token");
    localStorage.removeItem("kqm_mode");
    setUser(false);
    setEmployee(null);
    setCompany(null);
  };

  const impersonate = async (userId) => {
    localStorage.removeItem("kqm_mode");
    const { data } = await api.post(`/support/impersonate/${userId}`);
    if (data.token) localStorage.setItem("kqm_token", data.token);
    await refresh();
  };

  const enterCompany = async (cid) => {
    localStorage.removeItem("kqm_mode");
    const { data } = await api.post(`/support/enter-company/${cid}`);
    if (data.token) localStorage.setItem("kqm_token", data.token);
    await refresh();
  };

  const switchMode = async (mode) => {
    if (mode === "employee") localStorage.setItem("kqm_mode", "employee");
    else localStorage.removeItem("kqm_mode");
    await refresh();
  };

  const stopImpersonate = async () => {
    localStorage.removeItem("kqm_mode");
    const { data } = await api.post("/support/stop-impersonate");
    if (data.token) localStorage.setItem("kqm_token", data.token);
    await refresh();
  };

  return (
    <AuthContext.Provider value={{ user, employee, company, login, logout, refresh, impersonate, enterCompany, stopImpersonate, switchMode }}>
      {children}
    </AuthContext.Provider>
  );
}
